import { Doctor } from "../doctor/doctor.interface";
import { Company } from "../company/company.interface";
import { SalesLine } from "./sales-return-line.interface";
import { Account } from "../account/account.interface";

export interface SalesReturn {
    id: number;
    sales_return_no: string;
    sales_return_date: Date;
    sales_ret_type: string;
    sales_lines: SalesLine[];
    type: string;
    total_amount: number;
    change_amount_total: number;
    sgst: number;
    cgst: number;
    igst: number;
    sgst_amount: number;
    cgst_amount: number;
    igst_amount: number;
    grand_total: number;
    status: string;
    discount_amount: number;
    doctor_id: number;
    doctor: Doctor;
    doctor_name: string;
    parent_id: number;
    invoice_id: number[];
    company_id: number;
    account_id: number;
    company_name: string;
    company: Company;
    account: Account;
};

export var displayColumns = [
    'sales_return_no',
    'sales_return_date',
    'doctor_name',
	'company_name',
    'grand_total',
    'status',
]
export var displayHeaders = [
    'No.',
    'Date',
    'Doctor Name',
	'Company Name',
    'Grand Total',
    'Status',
]


// actual database columns
export var orderByColumns = [
    'sales_return_no',
    'sales_return_date',
    'doctor_name',
	'company_name',
    'grand_total',
    'status'
]

// for dropdown the options are set via ts file, so modify the code there
export const filterParameters = [
    { 
        name: 'sales_return_date', 
        type: 'date_range', 
        operator: 'between', 
        label: 'Select Date Range' 
    },
    { 
        name: 'sales_return_no', 
        type: 'string', 
        operator: 'like', 
        label: 'No.', 
    },
    { 
        name: 'doctor_id', 
        type: 'dropdown', 
        model_name:'doctor',
        operator: '=',
        label: 'Doctor' 
    },
    { 
		name: 'company_id', 
		type: 'dropdown', 
		operator: '=',
		model_name:'company',
		label: 'Company' 
	},
    { 
        name: 'status', 
        type: 'radio_option', 
        operator: '=',
        values: [
                    { label: 'Draft', value: "draft" },
                    { label: 'Submitted', value: "submitted" },
                    { label: 'Cancelled', value: "cancelled" }
                ],
        model_name:'sales_return',
        label: 'Status' 
    },
    { 
        name: 'order_by_columns', 
        type: 'multi_select', 
        operator: 'order_by_columns',
        values: displayHeaders.map((header, index) => ({
                label: header,
                value: orderByColumns[index]
            })),
        model_name:'sales_return',
        label: 'Select columns for order by' 
    }
];  

